import API from "api";

export const uploadProfilePhoto = async (file) => {
  const formData = new FormData();
  formData.append("photo", file);
  const { data } = await API.post("/profile/photo", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.user;
};
